import ApiService from '@/services/apiService';

export const transformSearchItemsForDisplayMixin = {
  computed: {
    operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned'),
      };
    },
  },
  methods: {
    async transformSearchItemsForDisplay(searchItems) {
      let result;

      return await Promise.all(
        searchItems.map(async (item) => {
          // guarding so if item.search is already an object, don't transform it again
          if (typeof item.search === 'object' && item.search !== null && 'value' in item.search) {
            return item;
          }

          switch (item.variable) {
            case 'operationalStatus':
              item.search = {
                value: item.search,
                text: this.operationalStatus[item.search],
              };
              break;

            case 'deviceDriver':
              result = await ApiService.virtualDeviceDrivers.fetchOneById(item.search);

              item.search = {
                value: item.search,
                text: result.title,
              };
              break;

            case 'parentId':
              result = await ApiService.digitalTwinGet(this, item.search);

              item.search = {
                value: item.search,
                text: result.title,
              };
              break;
          }

          return item;
        })
      );
    },
  },
};
